import React from 'react';
import SmallLoader from '@shared/components/SmallLoader';
import { MESSAGE_FETCHING_CHART_DATA } from '@/constants/messages';

const ChartPlaceholderLoading = () => {
  return (
    <div className="chart-placeholder-loading">
      <SmallLoader
        disableAnimations
        isFlexDisplay
        primaryMessage="Loading..."
        secondaryMessage={MESSAGE_FETCHING_CHART_DATA}
      />
    </div>
  );
};

export default ChartPlaceholderLoading;
